module.exports = __webpack_public_path__ + "img/nf.3b25e74d.png";